import React from 'react';

const DZ = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_162"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_162)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H10V15H0V0Z"
        fill="#357C58"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.052 10.263C12.23 11.32 10.944 12 9.5 12C7.015 12 5 9.985 5 7.5C5 5.015 7.015 3 9.5 3C10.944 3 12.23 3.68 13.052 4.737C12.417 4.275 11.618 4 10.75 4C8.68 4 7 5.567 7 7.5C7 9.433 8.68 11 10.75 11C11.618 11 12.417 10.725 13.052 10.263Z"
        fill="#E82E2E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 7.5L14 7L14.5 6L15 7L16 7.5L15 8L14.5 9L14 8L13 7.5Z"
        fill="#E82E2E"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default DZ;
